import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import purchaseSuccessIcon from '../../assets/icons/purchase-success.svg';
import './manualPurchase.css';

const PurchaseModal = ({
  open,
  title,
  subtitle,
  onClose,
  busy = false,
  success = false,
  children,
  footer,
}) => {
  const ref = useRef(null);
  const headingRef = useRef(null);
  useEffect(() => {
    const dialog = ref.current;
    if (open && !dialog.open) {
      dialog.showModal();
      headingRef.current?.focus({ preventScroll: true });
      dialog.scrollTop = 0;
    }
    if (!open && dialog.open) dialog.close();
  }, [open]);
  return createPortal(
    <dialog
      ref={ref}
      aria-label={title}
      onCancel={event => {
        event.preventDefault();
        if (!busy) onClose();
      }}
      className='purchase-modal m-auto w-[calc(100%-2rem)] max-w-[587px] max-h-[90vh] rounded-[15px] bg-white p-0 text-slate-700 backdrop:bg-black/50'
    >
      <div className='purchase-modal-heading flex items-start gap-[10px] p-5'>
        {success && (
          <img
            src={purchaseSuccessIcon}
            alt=''
            className='h-[52px] w-[52px] shrink-0'
          />
        )}
        <div>
          <h2
            ref={headingRef}
            tabIndex={-1}
            className='text-xl leading-8 font-semibold focus:outline-none'
          >
            {title}
          </h2>
          {subtitle && <p className='text-sm text-gray-500'>{subtitle}</p>}
        </div>
      </div>
      <div className='space-y-5 p-5'>{children}</div>
      {footer && (
        <div className='flex flex-wrap justify-end gap-[18px] px-5 pb-5'>
          {footer}
        </div>
      )}
    </dialog>,
    document.body
  );
};

export default PurchaseModal;
